// extracted by mini-css-extract-plugin
export default {"imagesContainer":"cT_dj","cardsContainer":"cT_kS"};